export const PRIVACY_CHANNELS = [
  { key: "website", labelKey: "privacy.channel.website" },
  { key: "newsletter", labelKey: "privacy.channel.newsletter" },
  { key: "socials", labelKey: "privacy.channel.socials" },
  {
    key: "promotionalMaterials",
    labelKey: "privacy.channel.promotional_materials",
  },
  {
    key: "internalPublications",
    labelKey: "privacy.channel.internal_publications",
  },
  { key: "localMedia", labelKey: "privacy.channel.local_media" },
  { key: "videoRecordings", labelKey: "privacy.channel.video_recordings" },
];

export const DEFAULT_VISIBILITY = "UNSET";

export const normalizePrivacyVisibility = (value) => {
  if (!value) return DEFAULT_VISIBILITY;
  if (value === "HIDDEN") return "NOT_VISIBLE";
  return value;
};

export const PRIVACY_VISIBILITY_OPTIONS = [
  {
    value: "VISIBLE",
    labelKey: "privacy.visibility_options.visible",
  },
  {
    value: "NOT_VISIBLE",
    labelKey: "privacy.visibility_options.not_visible",
  },
  {
    value: "UNSET",
    labelKey: "privacy.visibility_options.unset",
  },
];

export const buildInitialChannels = (seed) => {
  const initial = {};
  PRIVACY_CHANNELS.forEach(({ key }) => {
    initial[key] = !!seed?.[key];
  });
  return initial;
};
